import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=c1348fca&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1348fca')) {
      api.createRecord('c1348fca', component.options)
    } else {
      api.reload('c1348fca', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=c1348fca&", function () {
      api.rerender('c1348fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eR52NmIbZkpC/JS/offershelp.vue"
export default component.exports